export default __webpack_public_path__ + "static/media/split_background.f3884c51.svg";